export default function initTabbed() {
    document.querySelectorAll('[data-tabbed]').forEach((tabs) => {
        const buttons = tabs.querySelectorAll('[data-tab-target]');
        const panes = tabs.querySelectorAll('[data-tab-pane]');
        if (!buttons.length || !panes.length) return;

        const activate = (key) => {
            buttons.forEach((btn) => {
                const match = btn.getAttribute('data-tab-target') === key;
                btn.classList.toggle('is-current', match);
                btn.setAttribute('aria-selected', match ? 'true' : 'false');
            });
            panes.forEach((pane) => {
                pane.classList.toggle('is-active', pane.getAttribute('data-tab-pane') === key);
            });
        };

        buttons.forEach((btn) => {
            btn.addEventListener('click', () => activate(btn.getAttribute('data-tab-target')));
        });

        // Keyboard navigation (Left/Right arrows through tabs)
        buttons.forEach((btn, i) => {
            btn.addEventListener('keydown', (e) => {
                if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
                e.preventDefault();
                const next = e.key === 'ArrowRight'
                    ? (i + 1) % buttons.length
                    : (i - 1 + buttons.length) % buttons.length;
                buttons[next].focus();
                activate(buttons[next].getAttribute('data-tab-target'));
            });
        });
    });
}
